// React Imports
import { useState, useEffect, useRef, useLayoutEffect } from "react";
import { useLocation, useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import globalText from "../../../../utils/globalText";
import TEXT from "../../../../utils/globalText";

// Icons Imports
import ICONS from "../../../../assets/Icons";

// Redux Imports
import {
  addFieldForceTxnLabel,
  fieldForceTxnDeniedApproval,
  fieldForceTxnWaitingApproval,
  getSpecificfieldForceTxn,
  removeFieldForceTxnLabel,
} from "../../../../redux/features/fieldForceTransaction";
import { getSpecificFieldForceRequest } from "../../../../redux/features/fieldForceRequest";

// Component Imports
import SmallPopupWithBulletPoints from "../../../../components/_utils/CommonSmallPopupWithBulletPoint";
import MediumImagePopup from "../../../../components/_utils/MediumImagePopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import TimelinePopupContent from "../../../../components/_utils/TimelinePopupContent";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import formatCurrency from "../../../../utils/CurrencyFormater";
import CommonInfoBox from "../../../../components/_utils/CommonInfoBox";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import TimelineStatusBar from "../../../../components/_utils/TimelineCommonComponents/TimelineStatusBar";
import CommonAlertCard from "../../../../components/_utils/CommonAlertCard";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import Chips from "../../../../components/_utils/CommonButtons/Chips";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import CommonToast from "../../../../components/_utils/CommonToast";

// Popup Imports
import FieldForceAccountDetailsPopup from "../../../../components/_utils/FieldForceAccountDetailsPopup";
import OwnerAccountDetailsPopUp from "../../../../components/Accounts/OwnerAccount/OwnerAccountDetailsPopUp";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import FieldForceTxnViewAllPopup from "../../../../components/FieldForceTransactionComp/FieldForceTxnViewAllPopup";

// Utils Imports

import useCategories from "../../../../utils/useCategories";
import {
  errorcode,
  GlobalConfiguration,
  IntervalConfiguration,
  RejectReasonLength,
} from "../../../../utils/configurationProvider";
import {
  getOutsideBankingHoursLabel,
  isOutsideBankingHours,
} from "../../../../utils/bankingHours";

import { toast } from "react-toastify";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import CommonTimeLineCard, {
  addLifeCycleStatus,
} from "../../../../components/CommonTimeLineCard";
import useRestrictedAction from "../../../../hooks/useRestrictedAction";

const FieldForceTransactionDetails = ({
  bene_txn_id,
  type,
  setTransactionFilterData,
  setTransactionFilterID,
  typeMulti,
  typeSingle,
  setParentTxnList,
  closeBeneTxnDetailModal,
}) => {
  const dispatch = useDispatch();

  const isSubmittingRef = useRef(false);
  const leftContentRef = useRef(null);
  const labelActionDispatchedRef = useRef(false);
  const cardRefs = useRef({});
  const cardRefsDist = useRef({});

  const location = useLocation();
  const navigate = useNavigate();
  const categoryMapper = useCategories();
  const previousStatus = useLocation()?.state?.options?.state;

  const { id: idFromParams } = useParams();
  const id = bene_txn_id ?? idFromParams;

  const [declineReason, setDeclineReason] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [HistoryPopup, setHistoryPopup] = useState(false);
  const [TxnHistoryid, setTxnHistoryid] = useState("");
  const [TxnHistoryAccountName, setTxnHistoryAccountName] = useState("");
  const [categoryName, setcategoryName] = useState("");
  const { typeSingleMob } = location.state || {};
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [showCategorySpecificDetails, setShowCategorySpecificDetails] =
    useState(
      typeSingle === "Category_Specific_Details" ||
        typeMulti === "MultiApproval_Session_Data" ||
        typeSingleMob === "Category_Specific_Details"
        ? true
        : false,
    );
  const [showSupportDetails, setShowSupportDetails] = useState(false);
  const [showRequestDetails, setShowRequestDetails] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [viewTxnDetails, setviewTxnDetails] = useState([]);
  const categoryIcon = categoryMapper(
    viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.category_id
      ?.category_id,
  );
  const [loading, setLoading] = useState(true);
  const [showDeclineModal, setShowDeclineModal] = useState(false);
  const [beneTxnDetailsID, setbeneTxnDetailsID] = useState("");
  const [infoBox, setInfoBox] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [fieldForceAccountDetailPopup, setFieldForceAccountDetailPopup] =
    useState(false);
  const [openImageUrl, setOpenImageUrl] = useState(false);
  const [selectedImage, setSelectedImage] = useState({});

  const [OwnerDetailpop, setOwnerDetailpop] = useState(false);
  const [showApprovalTimeline, setShowApprovalTimeline] = useState(false);
  const [showDistributionTimeline, setShowDistributionTimeline] =
    useState(false);
  const { services, data } = useSelector((state) => state.refreshToken);

  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [labels, setLabels] = useState([]);
  const [labelDetails, setLabelDetails] = useState([]);
  const [requestData, setRequestData] = useState(
    location.state?.requestData || null,
  );
  const [requestDataRequestId, setRequestDataRequestId] = useState(
    location.state?.requestData?.request_id || null,
  );

  const [btnClicked, setbtnClicked] = useState({});
  const [opentimelinepopup, SetopenTimelinePopup] = useState(false);

  const [index, setIndex] = useState(GlobalConfiguration?.lengthCheckZero);
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  const [openApprovalTimeline, setOpenApprovalTimeline] = useState([]);
  const [openDistributionTimeline, setOpenDistributionTimeline] = useState([]);
  const [copiedSupportField, setCopiedSupportField] = useState(null);
  const [showBankingHoursPopup, setShowBankingHoursPopup] = useState(false);

  const copyTextRef = useRef(null);
  const handleSupportIdCopy = async (id, field) => {
    try {
      await navigator.clipboard.writeText(id);
      setCopiedSupportField(field);

      clearTimeout(copyTextRef.current);

      copyTextRef.current = setTimeout(() => {
        setCopiedSupportField(null);
      }, IntervalConfiguration.intervalMedium);
    } catch (error) {
      console.error(error);
    }
  };

  const resetAllTimelines = () => {
    setOpenApprovalTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.logs?.length ||
          GlobalConfiguration.lengthCheckZero,
      ).fill(false),
    );

    setOpenDistributionTimeline(
      new Array(
        viewTxnDetails?.[GlobalConfiguration.lengthCheckZero]?.distribution_logs
          ?.length || 0,
      ).fill(false),
    );
  };
  const { fieldForceTxnDetailData } = useSelector(
    (state) => state.fieldForceTransaction,
  );

  const fieldForce_account_id =
    fieldForceTxnDetailData?.transaction?.[0]?.field_force_account_id;

  const isOutsideBankingHoursNow = isOutsideBankingHours();
  const hasApprovalService = services?.includes("AFieldForceTxn");

  const lifecycleStatus = viewTxnDetails?.[0]?.lifecycle_status;
  const accountApprovalStatus =
    viewTxnDetails?.[0]?.field_force_account_approval_status;

  // Detail page only: require approval or account pending (not approved/rejected)
  const isRequireApprovalState =
    lifecycleStatus === "pending" && accountApprovalStatus === "approved";

  const isAccountPendingState =
    lifecycleStatus === "pending" && accountApprovalStatus === "pending";

  const shouldShowBankingHoursAlert =
    hasApprovalService &&
    isOutsideBankingHoursNow &&
    (isRequireApprovalState || isAccountPendingState);

  const PopupcloseIcons = () => {
    resetAllTimelines();
    SetopenTimelinePopup(false);
    setShowApprovalTimeline(false);
    setShowDistributionTimeline(false);
  };

  async function fetchData() {
    if (!id) return;
    setLoading(true);

    try {
      let response;

      response = await dispatch(getSpecificfieldForceTxn(id));
      setLabels(response?.payload?.summary?.available_labels ?? []);
      setLabelDetails(response?.payload?.transaction?.[0]?.labels || []);
      setShowAssignedLabels(false);
      setShowCategorySpecificDetails(false);
      setIndex(GlobalConfiguration.lengthCheckZero);
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("*");
      }
    } catch (error) {
      console.error("Failed to load the transaction details", error);
    } finally {
      setLoading(false);
    }
  }

  const handleClose = () => {
    setShowLabelsPopup(false);
    toggleAssignedLabels();
    setIndex(GlobalConfiguration?.lengthCheckOne);
  };

  const finalize = () => {
    setShowLoader(false);
    setDeclineReason("");
  };

  const syncTxnToParentList = (txnId, mapper) => {
    if (!setParentTxnList || !txnId) return;

    setParentTxnList((prev) => {
      if (!Array.isArray(prev)) return [];

      return prev.map((txn) => {
        if (String(txn.txn_id) !== String(txnId)) return txn;

        return mapper(txn);
      });
    });
  };

  const applyTxnDetailUpdate = (txnId, mapper) => {
    setviewTxnDetails((prev) =>
      prev.map((item) => {
        if (prev.length > GlobalConfiguration.lengthCheckOne) {
          return String(item.txn_id) !== String(txnId) ? item : mapper(item);
        }

        return mapper(item);
      }),
    );
    syncTxnToParentList(txnId, mapper);
  };

  const handleTimelinePopup = () => {
    if (type === "bene_txn_detail_modal") {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowApprovalTimeline(true);
      if (!showApprovalTimeline) {
        setShowCategorySpecificDetails(false);
        setShowDistributionTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenDistributionTimeline(false);
    }
  };

  const toggleCategorySpecificDetails = () => {
    setShowCategorySpecificDetails(true);
    setShowAssignedLabels(false);
    setShowSupportDetails(false);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowCategorySpecificDetails(false);
    setShowSupportDetails(false);
  };

  const toggleSupportDetails = () => {
    setShowSupportDetails(true);
    setShowAssignedLabels(false);
    setShowCategorySpecificDetails(false);
  };

  const toggleRequestDetails = () => {
    setShowRequestDetails(true);
    setShowAssignedLabels(false);
    setShowSupportDetails(false);
  };

  const handleApproveTransaction = async (txnId) => {
    CommonToast({
      text: "Approving transaction",
      icon: ICONS?.LOADER_GIF,
      variant: "var(--processing)",
      buttonNeeded: false,
      btnProps: {
        enabledBgColor: "var(--primary-bg)",
        enabledTextColor: "var(--text-primary)",
        btnText: "",
        handleFunction: () => {},
        icon: "",
        btnType: "button",
        isDisabled: false,
        hoverOption: "white",
      },
    });

    setTimeout(() => toast.dismiss(), IntervalConfiguration.intervalMedium);

    const res = await dispatch(fieldForceTxnWaitingApproval(txnId));

    // if (res?.payload === undefined) {
    //   setNetworkError(
    //     "An error occured while taking action on this transaction",
    //   );
    //   setTimeout(
    //     () =>
    //       showErrorToast(
    //         "An error occured while taking action on this transaction",
    //       ),
    //     IntervalConfiguration.intervalExtraLarge,
    //   );
    //   return;
    // }

    if (res?.payload === undefined) {
      const msg = "An error occured while taking action on this transaction";
      applyTxnDetailUpdate(txnId, (item) => ({
        ...item,
        message: msg,
        error: true,
      }));
      setbtnClicked((prev) => ({ ...prev, [txnId]: "none" }));
      setTimeout(
        () => showErrorToast(msg),
        IntervalConfiguration.intervalExtraLarge,
      );
      return;
    }

    if (res?.payload?.errors?.user_unauthorized?.[0]) {
      setTimeout(() => {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceTxn" },
        });
      }, IntervalConfiguration.intervalExtraLarge);
      return;
    }

    // if (res?.payload?.status === false) {
    //   const base = res?.payload?.errors?.base;
    //   if (base?.[0]?.errors) {
    //     const reasons = base[0].errors[0]?.reason;
    //     if (Array.isArray(reasons)) {
    //       reasons.forEach((msg) => {
    //         setTimeout(
    //           () => showErrorToast(msg),
    //           IntervalConfiguration.intervalMedium,
    //         );
    //       });
    //       setErrorMessage(reasons[0]);
    //     } else {
    //       setErrorMessage(reasons);
    //       setTimeout(
    //         () => showErrorToast(reasons),
    //         IntervalConfiguration.intervalLarge,
    //       );
    //     }
    //   } else if (base?.[0]?.reason?.[0]) {
    //     setErrorMessage(base[0].reason[0]);
    //     setTimeout(
    //       () => showErrorToast(base[0].reason[0]),
    //       IntervalConfiguration.intervalMedium,
    //     );
    //   } else if (base?.[0]) {
    //     setErrorMessage(base[0]);
    //     setTimeout(
    //       () => showErrorToast(base[0]),
    //       IntervalConfiguration.intervalExtraLarge,
    //     );
    //   }
    //   setbtnClicked((prev) => ({
    //     ...prev,
    //     [txnId]: "none",
    //   }));
    //   return;
    // }

    if (res?.payload?.status === false) {
      const base = res?.payload?.errors?.base;
      let finalMsg = "An error occurred while approving this transaction";

      if (base?.[0]?.errors) {
        const reasons = base[0].errors[0]?.reason;
        if (Array.isArray(reasons)) {
          finalMsg = reasons[0];
          reasons.forEach((msg) => {
            setTimeout(
              () => showErrorToast(msg),
              IntervalConfiguration.intervalMedium,
            );
          });
        } else {
          finalMsg = reasons;
          setTimeout(
            () => showErrorToast(reasons),
            IntervalConfiguration.intervalLarge,
          );
        }
      } else if (base?.[0]?.reason?.[0]) {
        finalMsg = base[0].reason[0];
        setTimeout(
          () => showErrorToast(finalMsg),
          IntervalConfiguration.intervalMedium,
        );
      } else if (base?.[0]) {
        finalMsg = base[0];
        setTimeout(
          () => showErrorToast(finalMsg),
          IntervalConfiguration.intervalExtraLarge,
        );
      }

      applyTxnDetailUpdate(txnId, (item) => ({
        ...item,
        message: finalMsg,
        error: true,
      }));

      setbtnClicked((prev) => ({
        ...prev,
        [txnId]: "none",
      }));
      return;
    }

    const approvedLifecycle = res?.payload?.transactions?.[0]?.lifecycle_status;
    const approvedDistribution =
      res?.payload?.transactions?.[0]?.distribution_lifecycle_status;
    const approvedLogs = res?.payload?.transactions?.[0]?.logs;
    const distributionLogs = res?.payload?.transactions?.[0]?.distribution_logs;

    const uiState = addLifeCycleStatus({
      lifecycle_status: approvedLifecycle,
      distribution_lifecycle_status: approvedDistribution,
      services,
    });

    applyTxnDetailUpdate(txnId, (item) => ({
      ...item,
      lifecycle_status: approvedLifecycle ?? item?.lifecycle_status,
      distribution_lifecycle_status:
        approvedDistribution ?? item?.distribution_lifecycle_status,
      last_updated_status: res?.payload?.transactions?.[0]?.last_updated_status,
      last_updated_user_id:
        res?.payload?.transactions?.[0]?.last_updated_user_id,
      distribution_logs: distributionLogs,
      logs: approvedLogs ?? item?.logs,
      ...uiState,
    }));

    setTimeout(() => {
      CommonToast({
        text: "Transaction approved successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }, IntervalConfiguration.intervalMedium);

    if (type === "bene_txn_detail_modal") {
      setTimeout(() => {
        closeBeneTxnDetailModal?.();
      }, IntervalConfiguration.intervalExtraLarge);
    }
  };

  const handleReject = async (txnId, reason) => {
    if (isSubmittingRef.current) return;
    isSubmittingRef.current = true;

    try {
      UniversalRefreshToast("Rejecting transaction");
      const hasService = services?.find(
        (s) => s === "AFieldForceTxn" || s === "Admin",
      );

      if (!hasService) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceTxn, Admin" },
        });
        return;
      }

      if (!sessionStorage.getItem("q2p_token")) return;

      setShowLoader(true);

      const result = await dispatch(
        fieldForceTxnDeniedApproval({ id: txnId, AccountIdData: reason }),
      );
      const payload = result?.payload;

      await new Promise((resolve) =>
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge),
      );

      if (payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: { unavailableService: "AFieldForceTxn, Admin" },
        });
        return finalize();
      }

      if (payload?.status === errorcode.errorFailed) {
        CommonToast({
          text: payload?.error || "Something went wrong",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        return finalize();
      }

      const tx = payload?.transactions?.[0];
      const rejectedLogs = tx?.logs;

      let newLifecycleStatus = "error";
      if (payload?.status === true) {
        newLifecycleStatus =
          tx?.lifecycle_status === "rejected"
            ? "rejected"
            : tx?.lifecycle_status === "pending"
              ? "pendingOne"
              : "error";
      }

      let rejectErrorMsg = "";
      if (payload?.errors?.base?.[0]?.errors) {
        payload.errors.base[0].errors.forEach((msg) => {
          if (payload?.status === false) {
            CommonToast({
              text: msg,
              icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
              variant: "var(--error)",
              btnProps: {
                isDisabled: false,
                enabledTextColor: "var(--text-primary)",
                enabledBgColor: "var(--primary-bg)",
              },
            });
          }
        });
        rejectErrorMsg = payload.errors.base[0].errors[0];
      } else if (payload?.errors?.base?.[0]) {
        rejectErrorMsg = payload.errors.base[0];
      }

      const uiState = addLifeCycleStatus({
        lifecycle_status: newLifecycleStatus,
        distribution_lifecycle_status: tx?.distribution_lifecycle_status,
        services,
      });

      applyTxnDetailUpdate(txnId, (item) => ({
        ...item,
        lifecycle_status:
          item.lifecycle_status === "pending" && payload?.status === true
            ? newLifecycleStatus
            : "error",
        rejected: true,
        rejection_reason: reason,
        logs: rejectedLogs ?? item?.logs,
        error: payload?.status === false ? "true" : "false",
        message: payload?.status === false ? rejectErrorMsg : "",
        ...uiState,
      }));

      if (payload?.status === false) {
        CommonToast({
          text:
            payload?.errors?.base?.[0]?.errors?.[0] ||
            payload?.errors?.base?.[0] ||
            "Error occurred",
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      } else {
        CommonToast({
          text: "Transaction rejected successfully.",
          icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        if (type === "bene_txn_detail_modal") {
          setTimeout(() => {
            closeBeneTxnDetailModal?.();
          }, IntervalConfiguration.intervalExtraLarge);
        }
      }

      finalize();
    } catch (error) {
      CommonToast({
        text: "Something went wrong",
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    } finally {
      isSubmittingRef.current = false;

      setbtnClicked((prev) => ({
        ...prev,
        [txnId]: "none",
      }));
      toast.dismiss();
      setShowDeclineModal(false);
    }
  };

  const handleDeclinedDetails = (id) => {
    setbeneTxnDetailsID(id);
    setShowDeclineModal(true);
  };

  const closeBeneAccountDetailModal = () => {
    setFieldForceAccountDetailPopup(false);
  };

  const closeFieldForceTxnDetailsModal = () => {
    setHistoryPopup(false);
  };

  const showAmountInfo = () => {
    setInfoBox(!infoBox);
  };

  const handleInputChange = (event) => {
    const value = event.target.value;

    const sanitizedValue = value.replace(/[^a-zA-Z0-9\s]/g, "");

    const limitedValue = sanitizedValue.slice(
      GlobalConfiguration.lengthCheckZero,
      RejectReasonLength.lengthOfDecline,
    );

    setDeclineReason(limitedValue);
  };

  const closeModal = () => {
    if (infoBox || showDeclineModal) {
      setInfoBox(false);
      // setShowDeclineModal(false);
    }
  };

  const showErrorToast = (text) => {
    CommonToast({
      text,
      icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
      variant: "var(--error)",
      btnProps: {
        isDisabled: false,
        enabledTextColor: "var(--text-primary)",
        enabledBgColor: "var(--primary-bg)",
      },
    });
  };

  const { showRestrictedAction, RestrictedActionPopup } = useRestrictedAction();

  const actionRestricted = () => {
    showRestrictedAction({
      path: `/field_force_transaction_dashboard/field_force_transaction_view_all/field_force_transaction_detail_page/${id}`,
    });
  };

  const additional_data =
    fieldForceTxnDetailData?.transaction[0]?.additional_data;

  const validItems = additional_data?.data ? additional_data?.data : [];
  const attachments = validItems.filter(
    (obj) =>
      (obj.data_type.toLowerCase() === "hyperlink" ||
        obj.data_type === "File" ||
        obj.data_type === "upload") &&
      "value" in obj,
  );
  const loginid = JSON.parse(sessionStorage.getItem("response"));

  const handleDistributionClick = () => {
    if (type === "bene_txn_detail_modal") {
      actionRestricted();
    } else {
      SetopenTimelinePopup(true);
      setShowDistributionTimeline(true);
      if (!showDistributionTimeline) {
        setShowCategorySpecificDetails(false);
        setShowApprovalTimeline(false);
        setShowAssignedLabels(false);
      }
      setOpenApprovalTimeline(false);
    }
  };

  const handleApprovalTimeline = (index) => {
    setOpenApprovalTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setOpenDistributionTimeline(
      Array(viewTxnDetails?.[0]?.distribution_logs?.length).fill(false),
    );
    if (!openApprovalTimeline[index]) {
      setTimeout(() => {
        cardRefs.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }, IntervalConfiguration?.intervalExtraSmall);
    }
  };

  const handleDistributionTimeline = (index) => {
    setOpenDistributionTimeline((prevOpenDivs) => {
      if (!Array.isArray(prevOpenDivs)) {
        return [];
      }
      const newOpenDivs = [...prevOpenDivs];
      newOpenDivs[index] = !newOpenDivs[index];
      return newOpenDivs;
    });
    setTimeout(() => {
      if (cardRefsDist?.current[index]) {
        cardRefsDist?.current[index]?.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, IntervalConfiguration?.intervalExtraSmall);
  };

  // const handleAssignLabelsProp = async (labelsToAssign) => {
  //   setLoading(true);

  //   const toArray = (value) => (Array?.isArray(value) ? value : [value]);
  //   const res = await dispatch(
  //     addFieldForceTxnLabel({
  //       record_ids: toArray(id),
  //       labels: labelsToAssign,
  //     }),
  //   );

  //   if (addFieldForceTxnLabel.fulfilled.match(res)) {
  //     fetchData();
  //     CommonToast({
  //       text: "Labels assigned successfully.",
  //       icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //       variant: "var(--success)",
  //       btnProps: {
  //         isDisabled: false,
  //         enabledTextColor: "var(--text-primary)",
  //         enabledBgColor: "var(--primary-bg)",
  //       },
  //     });
  //   }

  //   setLoading(false);
  //   if (addFieldForceTxnLabel?.fulfilled?.match(res)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };
  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addFieldForceTxnLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );

    if (addFieldForceTxnLabel.fulfilled.match(res)) {
      await fetchData(); // wait for it to finish resetting
      setShowAssignedLabels(true);
      setIndex(GlobalConfiguration.lengthCheckOne); // put tab back on Labels
      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLoading(false);
    if (addFieldForceTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  // const handleUnassignLabelsProp = async (labelsToUnassign) => {
  //   setLoading(true);

  //   const toArray = (value) => (Array.isArray(value) ? value : [value]);

  //   const res = await dispatch(
  //     removeFieldForceTxnLabel({
  //       record_ids: toArray(id),
  //       labels: labelsToUnassign,
  //     }),
  //   );

  //   if (removeFieldForceTxnLabel.fulfilled.match(res)) {
  //     fetchData();
  //     CommonToast({
  //       text: "Labels unassigned successfully.",
  //       icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
  //       variant: "var(--success)",
  //       btnProps: {
  //         isDisabled: false,
  //         enabledTextColor: "var(--text-primary)",
  //         enabledBgColor: "var(--primary-bg)",
  //       },
  //     });
  //   }

  //   setLoading(false);
  //   if (removeFieldForceTxnLabel?.fulfilled?.match(res)) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeFieldForceTxnLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeFieldForceTxnLabel.fulfilled.match(res)) {
      await fetchData(); // wait for it to finish resetting
      setShowAssignedLabels(true);
      setIndex(GlobalConfiguration.lengthCheckOne); // put tab back on Labels
      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECT_ALL_WITH_WHITE_FILLED_CIRCLE,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }

    setLoading(false);
    if (removeFieldForceTxnLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    fetchData();
  }, [id]);

  // useEffect(() => {
  //   if (fieldForceTxnDetailData) {
  //     const uiState = addLifeCycleStatus({
  //       lifecycle_status:
  //         fieldForceTxnDetailData?.transaction?.[0]?.lifecycle_status,
  //       distribution_lifecycle_status:
  //         fieldForceTxnDetailData?.transaction?.[0]
  //           ?.distribution_lifecycle_status,
  //       services,
  //     });
  //     const newData = fieldForceTxnDetailData?.transaction?.map((account) => ({
  //       ...account,
  //       loading: false,
  //       error: false,
  //       message: "",
  //       last_updated_user_id_check: false,
  //       ...uiState,
  //     }));
  //     setviewTxnDetails(newData);
  //     setbeneTxnDetailsID(fieldForceTxnDetailData?.transaction[0]?.txn_id);
  //   }
  // }, [fieldForceTxnDetailData]);

  useEffect(() => {
    if (fieldForceTxnDetailData) {
      const uiState = addLifeCycleStatus({
        lifecycle_status:
          fieldForceTxnDetailData?.transaction?.[0]?.lifecycle_status,
        distribution_lifecycle_status:
          fieldForceTxnDetailData?.transaction?.[0]
            ?.distribution_lifecycle_status,
        services,
        previousStatus,
      });
      const newData = fieldForceTxnDetailData?.transaction?.map((account) => ({
        ...account,
        loading: false,
        error: false,
        message: "",
        last_updated_user_id_check: false,
        ...uiState,
      }));
      setviewTxnDetails(newData);
      setbeneTxnDetailsID(fieldForceTxnDetailData?.transaction[0]?.txn_id);
    }
  }, [fieldForceTxnDetailData, previousStatus]);

  const transactionRequestId =
    fieldForceTxnDetailData?.transaction?.[0]?.field_force_request_id;
  const providedRequestData = location.state?.requestData;
  const getRequestedAmount = (account) =>
    (String(requestDataRequestId) === String(account?.field_force_request_id)
      ? requestData?.requested_amount
      : null) ??
    account?.requested_amount ??
    account?.total_amount;

  useEffect(() => {
    if (!transactionRequestId) {
      setRequestData(null);
      setRequestDataRequestId(null);
      return;
    }

    if (
      providedRequestData?.request_id != null &&
      String(providedRequestData.request_id) === String(transactionRequestId)
    ) {
      setRequestData(providedRequestData);
      setRequestDataRequestId(transactionRequestId);
      return;
    }

    setRequestData(null);
    setRequestDataRequestId(null);
    let isCurrentRequest = true;

    dispatch(getSpecificFieldForceRequest(transactionRequestId)).then((res) => {
      if (!isCurrentRequest) return;

      const request = res?.payload?.request?.[0];
      if (request) {
        setRequestData(request);
        setRequestDataRequestId(transactionRequestId);
      }
    });

    return () => {
      isCurrentRequest = false;
    };
  }, [dispatch, providedRequestData, transactionRequestId]);

  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "")?.trim()?.length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration?.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      <>{RestrictedActionPopup}</>

      {showBankingHoursPopup && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop bg-opacity-dark-opacity justify-center z-z-index-modal">
          <SmallPopupWithBulletPoints
            headerTitle="Why transaction cannot be processed?"
            headerFontWeight="semibold"
            headerFontColor="negative-act"
            textSize="font-md"
            bulletPoints={[
              `Any transaction created or approved after banking hours i.e. between ${getOutsideBankingHoursLabel()} will be processed on the next bank working day.`,
              "Payments are time-critical (e.g., salary, vendor payment, or bill payment), consider the possible processing delay before proceeding.",
            ]}
            closeIconImage={ICONS?.CLOSE}
            closeModal={() => setShowBankingHoursPopup(false)}
          />
        </div>
      )}

      {showLabelsPopup && (
        <div
          onClick={(e) => {
            e.stopPropagation();
            setShowLabelsPopup(true);
          }}
          className="fixed left-left-base w-width-full top-top-base h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal"
        >
          <CommonAssignLabelPopup
            headerTitle="Assign/Unassign labels:"
            headersubtext="Labels will be used to generate statistics for the associated field force transactions."
            closehandleFunction={handleClose}
            closeisDisabled={false}
            labels={labels}
            setLabels={setLabels}
            LabelAccounts={id}
            isLabelPopupOpen={showLabelsPopup}
            filteredData={fieldForceTxnDetailData?.transaction}
            labelActionDispatchedRef={labelActionDispatchedRef}
            onClose={handleClose}
            loading={loading}
            setLoading={setLoading}
            handleAssignLabels={handleAssignLabelsProp}
            handleUnassignLabels={handleUnassignLabelsProp}
            type="details"
          />
        </div>
      )}

      {HistoryPopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <FieldForceTxnViewAllPopup
              closeFieldForceTxnDetailsModal={closeFieldForceTxnDetailsModal}
              TxnHistoryid={TxnHistoryid}
              TxnHistoryAccountName={TxnHistoryAccountName}
              categoryName={categoryName}
              type={"field_force_txnViewAll_popup"}
            />
          </div>
        </>
      )}
      {openImageUrl && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <MediumImagePopup
              image={selectedImage}
              closehandleFunction={() => {
                setOpenImageUrl(false);
              }}
            />
          </div>
        </>
      )}

      {opentimelinepopup && (
        <>
          <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
            <LargePopupRedirect
              headerTitle="Transaction timeline"
              headerFontWeight="semibold"
              headerFontColor="text-primary"
              headertextSize="font-md"
              closeiconenabledBgColor="var(--primary-nav)"
              closeiconisLoading={false}
              closeiconhandleFunction={PopupcloseIcons}
              closeicon={ICONS?.CLOSE}
              closeiconhoverOption="white"
              closeiconbtnType={"button"}
              closeiconisDisabled={false}
              closeicondisabledBgColor={""}
              closeiconbuttonRef={null}
              closeicontitle={"Close"}
              btnType={"button"}
              handleFunction={() => {}}
              enabledBgColor={"var(--positive-act)"}
              hoverOption={"dark"}
              outLineColor={""}
              enabledTextColor={"var(--text-primary)"}
              fullWidthRequired={false}
              isDisabled={false}
              disabledTextColor={""}
              disabledBgColor={""}
              isLoading={false}
              buttonRef={null}
              inActiveVariantNeeded={false}
              isLoaderNeeded={false}
              isscrollRequired={true}
            >
              <TimelinePopupContent
                logsData={viewTxnDetails}
                handleApprovalClick={handleTimelinePopup}
                handleDistributionClick={handleDistributionClick}
                showDistributionRightIcon={false}
                showApprovalLeftIcon={false}
                showApprovalTimeline={showApprovalTimeline}
                openApprovalTimeline={openApprovalTimeline}
                handleApprovalTimeline={handleApprovalTimeline}
                showDistributionTimeline={showDistributionTimeline}
                openDistributionTimeline={openDistributionTimeline}
                handleDistributionTimeline={handleDistributionTimeline}
                setOpenDistributionTimeline={setOpenDistributionTimeline}
                setOpenApprovalTimeline={setOpenApprovalTimeline}
                cardType={"double"}
                popUpMode={true}
              />
            </LargePopupRedirect>
          </div>
        </>
      )}
      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-Primary-black justify-center z-z-index-max bg-opacity-dark-opacity">
          <FullScreen
            type={"txn"}
            id={bene_txn_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}
      <div
        className={`bg-primary-bg overflow-x-hidden ${showDeclineModal ? "overflow-y-hidden" : "overflow-y-auto"}`}
        style={{
          height:
            type === "bene_txn_detail_modal"
              ? "var(--height-full)"
              : "var(--full-height)",
        }}
        onClick={closeModal}
      >
        {loading ? (
          <div className="bene-detail-loader-box m-auto justify-center items-center flex">
            <Loader />
          </div>
        ) : (
          <>
            {type !== "bene_txn_detail_modal" ? (
              <div className="Qsmd:flex hidden h-navbar-breadcrumb-height bg-primary-nav w-width-full"></div>
            ) : null}

            <div
              className={`beneTxnDetailsPage ${
                type === "bene_txn_detail_modal" ? "" : ""
              }`}
            >
              {showDeclineModal && (
                <div className="fixed top-top-base left-left-base w-full h-full bg-custom-backdrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                  <SmallPopupWithBulletPoints
                    headerTitle={TEXT?.REJECT_REASON_TXN_TITLE}
                    headerFontWeight="semibold"
                    headerFontColor="text-primary"
                    textSize="font-md"
                    subtext={TEXT?.PROVIDE_REJECT_REQUEST_REASON_PROMPT}
                    bulletPoints={[
                      "Transaction will be rejected, and distribution will not be initiated.",
                      "Transaction cannot be edited.",
                    ]}
                    inputAdornment={false}
                    inputVariant={computeVariant(declineReason, isFocused)}
                    inputOnFocus={(e) => setIsFocused(true)}
                    inputOnBlur={(e) => setIsFocused(false)}
                    inputBgColor="var(--primary-bg)"
                    inputFgColor="var(--text-secondary)"
                    inputOnInput={(e) => {
                      if (!showLoader) {
                        handleInputChange(e);
                      }
                    }}
                    inputValue={declineReason}
                    inputFontKind="big"
                    inputIsFullWidth={true}
                    btnOneText={TEXT?.CANCEL}
                    btnOneHandleFunction={() => {
                      if (!showLoader) {
                        setShowDeclineModal(false);
                        setDeclineReason("");

                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "none",
                        }));
                      }
                    }}
                    btnOneEnabledBgColor="var(--primary-bg)"
                    btnOneOutLineColor="var(--text-primary)"
                    btnOneEnabledTextColor="var(--text-primary)"
                    btnOneHoverOption="white"
                    btnOneIsDisabled={showLoader}
                    btnTwoText={TEXT?.REJECT}
                    btnTwoHandleFunction={() => {
                      if (
                        !declineReason ||
                        declineReason?.length <
                          GlobalConfiguration?.owneraccountnormalLength ||
                        showLoader
                      ) {
                        return;
                      }
                      handleReject(beneTxnDetailsID, declineReason);
                    }}
                    btnTwoEnabledBgColor="var(--negative-act)"
                    btnTwoEnabledTextColor="var(--text-primary)"
                    btnTwoIsDisabled={
                      !declineReason ||
                      declineReason?.length <
                        GlobalConfiguration?.owneraccountnormalLength
                    }
                    btnTwoDisabledBgColor="var(--text-disabled)"
                    btnTwoIsLoaderNeeded={showLoader ? true : false}
                    btnTwoIsLoading={showLoader ? true : false}
                    btnTwoHoverOption="black"
                    btnTwoInActiveVariantNeeded={true}
                    noteText={TEXT?.REJECT_POPUP_ACCOUNT_NOTE_TEXT}
                    isTextInputField={true}
                    inputPlaceholder={TEXT?.REASON}
                    subtextwithbullet="Y"
                  />
                </div>
              )}

              {fieldForceAccountDetailPopup && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
                  <FieldForceAccountDetailsPopup
                    closeBeneAccountDetailModal={closeBeneAccountDetailModal}
                    field_force_account_id={fieldForce_account_id}
                    setviewTxnDetails={setviewTxnDetails}
                    setParentTxnList={setParentTxnList}
                  />
                </div>
              )}

              {OwnerDetailpop && (
                <div className="fixed top-top-base left-left-base w-screen h-screen z-z-index-modal bg-Primary-black bg-opacity-dark-opacity">
                  <OwnerAccountDetailsPopUp
                    closeBeneAccountDetailModal={() => {
                      setOwnerDetailpop(false);
                    }}
                    Remibursement_owneraccount_id={
                      fieldForceTxnDetailData?.transaction?.[0]
                        ?.owner_account_id
                    }
                    type={"reimburseowner_details"}
                  />
                </div>
              )}

              <div
                className={`fixed top-top-base left-left-base mt-margin-base w-width-full z-z-index-header bg-primary-nav shadow-box-shadow-bottom ${
                  type === "bene_txn_detail_modal" ? "hidden" : "lg:hidden"
                } block`}
              >
                <TopNavComponent
                  isFormattingNotRequired={true}
                  topNavHeader={"Field Force"}
                  topNavSubText="Transaction details"
                />
              </div>

              {/* Top components */}
              <div
                className={`h-auto w-width-full bg-primary-nav ${type === "bene-txn-detail-modal" ? "pt-padding-base" : "Qsmd:pt-padding-base pt-padding-lg"} `}
              >
                <div
                  className={`bene-txn-account-primary-details ${type === "bene-txn-detail-modal" ? "" : "Qsmd:pt-padding-base pt-padding-lg"}`}
                >
                  {fieldForceTxnDetailData?.transaction?.map((account) => (
                    <div
                      key={account?.txn_id}
                      className="w-width-full h-auto bg-primary-nav"
                    >
                      <div className="flex flex-col lg:flex-row border-b border-solid border-primary-bg  mx-margin-md lg:mx-margin-base">
                        <div
                          className={`${type === "bene-txn-detail-modal" ? "lg:w-width-md" : "lg:w-width-md w-auto"} Qlg:px-padding-base justify-between flex flex-row gap-x-gap-sm items-center py-padding-md pl-padding-base  px-padding-base  Qlg:flex-shrink-0 flex-1`}
                        >
                          <div className="flex flex-col justify-start gap-y-gap-xs lg:pl-padding-sm">
                            <div className="flex flex-row gap-x-gap-xs relative">
                              <div>
                                <TitleSubtitlePair
                                  title={`INR ${formatCurrency(account?.total_amount)}`}
                                  titleColor="settled"
                                  subtitle="Approved amount"
                                  info={true}
                                  onClick={showAmountInfo}
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={true}
                                  variant="md"
                                />
                              </div>

                              {infoBox && (
                                <div className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity">
                                  <CommonInfoBox
                                    headerTitle="Amount Breakdown"
                                    transactionAmount={account.total_amount}
                                    transactionAmountColor={"settled"}
                                    transactionLabel="Transaction amount"
                                    finalAmountLabel="Amount credited"
                                    rows={[
                                      {
                                        label: "Amount debited",
                                        value: account.total_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,
                                      },
                                      {
                                        label: "Tax amount",
                                        value: account.tax_amount,
                                        icon: ICONS?.SUBTRACTION_WITH_ROUNDNESS,

                                        operation: "subtract",
                                      },
                                      {
                                        label: "Payment charge",
                                        value: account.payment_charge,

                                        operation: "subtract",
                                      },
                                    ]}
                                    headerFontColor="text-primary"
                                    headerFontWeight="semibold"
                                    textSize="font-md"
                                    onClosepop={() => setInfoBox(null)}
                                    popupBgColor="primary-bg"
                                  />
                                </div>
                              )}
                            </div>
                          </div>
                          <div className="lg:mr-margin-sm flex justify-end pr-padding-sm gap-y-gap-xs text-right min-w-0 break-all flex-wrap">
                            <TitleSubtitlePair
                              title={`INR ${formatCurrency(getRequestedAmount(account))}`}
                              {...(Number(getRequestedAmount(account)) !==
                                Number(account?.total_amount) && {
                                titleColor: "queued",
                              })}
                              subtitle="Requested amount"
                              onClick={showAmountInfo}
                              alignRight={true}
                              textAlign="right"
                              hoverOption="white"
                              isBold={true}
                              variant="md"
                            />
                          </div>
                        </div>

                        <div className="border-r border-solid border-primary-bg my-margin-md hidden lg:block"></div>
                        <div className="flex flex-row justify-between gap-x-gap-md w-width-full lg:w-width-md py-padding-md Qlg:py-padding-md px-padding-base lg:px-padding-base border-t lg:border-none border-solid border-primary-bg flex-1 align-middle items-center">
                          <div className="gap-y-gap-xs lg:px-padding-md">
                            <div>
                              <TitleSubtitlePair
                                title={account?.field_force_account_name}
                                titleColor="text-primary"
                                subtitle={"Account name"}
                                info={false}
                                alignRight={false}
                                hoverOption="white"
                                isBold={false}
                                variant="md"
                                titleCase=""
                              />
                            </div>
                          </div>
                          <div className="lg:mr-margin-sm flex justify-end pr-padding-sm gap-y-gap-xs text-right min-w-0 break-all flex-wrap">
                            <div>
                              <TitleSubtitlePair
                                isDisabled={false}
                                alignRight={true}
                                textAlign="right"
                                title={
                                  account.distribution_utr
                                    ? account.distribution_utr
                                    : "N/A"
                                }
                                titleColor={"text-primary"}
                                subtitle={globalText?.UTR_NUMBER}
                                info={false}
                                showArrow={false}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="hidden lg:flex flex-col justify-end gap-gap-base min-h-[var(--positive-negative-btn-width)]">
                          <div className="flex items-center h-full">
                            <TopNavSmallButton
                              btnText={
                                <>
                                  Linked
                                  <br />
                                  request
                                </>
                              }
                              btnType="button"
                              icon={ICONS?.LINKED_WHITE_CIRCLE}
                              handleFunction={() => {
                                if (type === "bene_txn_detail_modal") {
                                  actionRestricted();
                                } else if (account?.field_force_request_id) {
                                  navigate(
                                    `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${account?.field_force_request_id}`,
                                  );
                                } else {
                                  return;
                                }
                              }}
                              isDisabled={
                                type === "bene_txn_detail_modal"
                                  ? true
                                  : !account?.field_force_request_id
                                    ? true
                                    : false
                              }
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                              fullWidthRequired={false}
                            />
                          </div>
                        </div>
                      </div>

                      <div className="relative mx-margin-sm lg:mx-margin-base">
                        <div className="flex flex-col justify-between lg:flex-row lg:gap-gap-base h-auto lg:h-auto w-width-full">
                          <div
                            className={`flex flex-row pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md 
                              ${
                                type === "bene_txn_detail_modal"
                                  ? "lg:px-padding-base pr-padding-base pl-padding-base"
                                  : "lg:pl-padding-base pl-padding-base lg:pr-padding-base pr-padding-base "
                              }`}
                          >
                            <div
                              className={`${
                                !services?.includes("VAccount") ||
                                type === "bene_txn_detail_modal"
                                  ? " pl-padding-base pb-padding-base"
                                  : ""
                              }`}
                            >
                              <TitleSubtitlePair
                                isDisabled={
                                  type === "bene_txn_detail_modal" ||
                                  !services?.includes("VAccount")
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.owner_account_bank_acc_no,
                                )}
                                titleColor={"text-primary"}
                                subtitle={TEXT?.SOURCE_ACCOUNT}
                                onClick={() => {
                                  if (!services?.includes("VAccount")) {
                                    navigate("/feature_not_assigned", {
                                      state: {
                                        unavailableService: "VAccount",
                                      },
                                    });
                                    return;
                                  }

                                  if (type === "bene_txn_detail_modal") {
                                    actionRestricted();
                                  } else {
                                    setOwnerDetailpop(true);
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>
                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm ">
                              <CommonBankLogo
                                ifsc={account?.owner_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>

                          <div className="flex items-center gap-gap-sm justify-start Qlg:px-padding-md Qlg:hidden mx-margin-sm Qlg:mx-margin-base">
                            <div className="w-width-md border-b border-primary-bg"></div>
                            <div className="w-icon-md">
                              <img
                                src={ICONS?.ARROW_DOWN_BLUE_WHITE}
                                alt="arrowDownBlueWhite"
                              />
                            </div>
                            <div className="w-width-md border-b border-primary-bg"></div>
                          </div>

                          <div
                            className={`border-r border-solid border-primary-bg h-auto my-margin-lg hidden lg:block ${type === "bene_txn_detail_modal" ? "mt-margin-sm" : "mt-margin-md"}`}
                          ></div>
                          <div
                            className={`flex flex-row pt-padding-sm w-width-full lg:w-width-md justify-between lg:h-height-md lg:mb-margin-base mb-margin-sm ${type === "bene_txn_detail_modal" ? "lg:px-padding-base pr-padding-base pl-padding-base" : "lg:pl-padding-base pl-padding-base  lg:pr-padding-base pr-padding-base"}`}
                          >
                            <div className={`lg:ml-margin-sm `}>
                              <TitleSubtitlePair
                                isDisabled={
                                  type === "bene_txn_detail_modal"
                                    ? true
                                    : false
                                }
                                alignRight={false}
                                title={formatAccountNumber(
                                  account?.field_force_account_bank_acc_no,
                                ).toUpperCase()}
                                titleColor={"text-primary"}
                                subtitle={"Destination account"}
                                onClick={() => {
                                  if (type === "bene_txn_detail_modal") {
                                    actionRestricted();
                                  } else {
                                    setFieldForceAccountDetailPopup(true);
                                  }
                                }}
                                info={false}
                                showArrow={true}
                                hoverOption={"white"}
                                isBold={false}
                                variant={"md"}
                              />
                            </div>

                            <div className="bg-text-primary rounded-border-radius-md flex items-center justify-around h-toggle-btn-height px-padding-sm mt-margin-md lg:mr-margin-md mr-margin-sm Qlg:ml-margin-sm">
                              <CommonBankLogo
                                ifsc={account?.field_force_account_ifsc_code}
                                variant="big"
                                type="pill"
                              />
                            </div>
                          </div>

                          <div
                            className={`hidden lg:flex flex-col justify-end gap-gap-base min-h-[var(--positive-negative-btn-width)]`}
                          >
                            <TopNavSmallButton
                              btnText={
                                viewTxnDetails[0]?.category_id?.category_name
                              }
                              btnType="button"
                              icon={categoryIcon?.url}
                              imgColor={categoryIcon?.colour}
                              handleFunction={() => {
                                if (type === "bene_txn_detail_modal") {
                                  actionRestricted();
                                } else {
                                  setHistoryPopup(true);
                                  setTxnHistoryid(
                                    viewTxnDetails[0]?.field_force_account_id,
                                  );
                                  setTxnHistoryAccountName(
                                    viewTxnDetails[0]?.field_force_account_name,
                                  );
                                  setcategoryName(
                                    viewTxnDetails[0]?.category_id
                                      ?.category_name,
                                  );
                                }
                              }}
                              isDisabled={type === "bene_txn_detail_modal"}
                              enabledTextColor="var(--text-primary)"
                              enabledBgColor="var(--primary-nav-act)"
                              disabledBgColor="var(--primary-nav-act)"
                              hoverOption="white"
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        className={`border-primary-bg border-solid border-t lg:border-b flex flex-col h-auto items-center justify-between lg:border-none lg:flex-row lg:min-h-[var(--positive-negative-btn-width)] lg:px-padding-base lg:w-width-full mx-margin-md lg:mx-margin-base ${account?.field_force_account_approval_status === "pending" ? " border-primary-bg mx Qlg:border-none" : ""}`}
                      >
                        <div className="flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base w-width-full lg:flex-1 lg:min-w-0">
                          <div className="w-width-full flex flex-row h-auto items-center justify-between lg:border-none lg:flex-row lg:px-padding-base px-padding-base relative max-">
                            <div className="parent  flex flex-row py-padding-md lg:py-padding-base w-full Qlg:w-width-md lg:justify-between justify-end gap-gap-sm">
                              <div className="lg:flex flex-col gap-y-gap-xs hidden mr-margin-xl lg:pl-padding-sm">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account?.owner_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>

                              <div className="lg:hidden payment flex flex-col gap-y-gap-xs item-start ml-margin-lg mr-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={
                                    account.distribution_mode_of_payment ||
                                    account.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                              <div className="payment hidden lg:flex flex-col gap-y-gap-xs items-end item-start ml-margin-lg mr-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={true}
                                  textAlign={"right"}
                                  title={
                                    account.distribution_mode_of_payment ||
                                    account.payment_method ||
                                    "N/A"
                                  }
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.PAYMENT_METHOD}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>

                            <div className="border-primary-bg border-r border-solid hidden lg:block py-padding-md"></div>
                            <div
                              className="lg:flex justify-center items-center hidden z-z-index-content absolute bottom-[64px]"
                              style={{
                                left: "calc(var(--top-half) - var(--top-sm))",
                              }}
                            >
                              <img
                                src={ICONS?.ARROW_RIGHT_BLUE_WHITE}
                                className="w-icon-md h-icon-md"
                                alt="Transaction"
                              />
                            </div>
                            <div className="flex flex-row justify-between items-center gap-x-gap-md lg:gap-x-gap-xl pr-padding-md lg:pr-padding-base w-width-full lg:w-width-md">
                              <div className="hidden lg:flex flex-col justify-start items-start gap-y-gap-xs py-padding-sm mr-margin-xl ml-margin-md">
                                <TitleSubtitlePair
                                  isDisabled={false}
                                  alignRight={false}
                                  title={account.field_force_account_ifsc_code}
                                  titleColor={"text-primary"}
                                  subtitle={globalText?.IFSC_CODE}
                                  info={false}
                                  showArrow={false}
                                  isBold={false}
                                  variant={"md"}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="hidden lg:block w-topnav-small-btn-width self-stretch"></div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* Top components */}

              <div className="bg-primary-bg lg:hidden block lg:border-none border-primary-bg">
                <div className="flex flex-col w-width-full max-w-tab-width-normal m-auto">
                  {/* Mobile  */}
                  <TimelineStatusBar
                    showMobile={true}
                    key={viewTxnDetails?.[0]?.txn_id}
                    overrideAutoLoader
                    isLoading={loading}
                    failedToTakeaction={
                      false || "" || viewTxnDetails?.[0]?.message
                    }
                    failedToTakeactionReason={
                      false
                        ? "An error occurred while taking action on this transaction"
                        : ""
                          ? ""
                          : viewTxnDetails?.[0]?.message || ""
                    }
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length >
                      RejectReasonLength.lengthOfDecline
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]
                        ?.field_force_account_approval_status === "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("AFieldForceTxn")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("FFAAccount")
                        ? setFieldForceAccountDetailPopup(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "FFAAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      services?.find((service) => service === "FFAAccount") ===
                      undefined
                    }
                    furtherApprovalPending={
                      (viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        viewTxnDetails?.[0]?.approved === "N" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.action?.toLowerCase() === "approved" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.user_id === loginid?.employees?.id) ||
                      (viewTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        !services?.includes("AFieldForceTxn"))
                    }
                    furtherApprovalPendingSubHeader={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id
                        ? "This transaction has been approved by you, but it requires another user's approval before distribution."
                        : viewTxnDetails?.[0]?.last_updated_status ===
                              "Approved" &&
                            viewTxnDetails?.[0]?.lifecycle_status ===
                              "pending" &&
                            !services?.includes("AFieldForceTxn")
                          ? "This transaction requires another user's approval before distribution."
                          : ""
                    }
                    pending={
                      viewTxnDetails?.[0]
                        ?.field_force_account_approval_status === "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    rejectMobClick={() => {
                      if (services?.includes("AFieldForceTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AFieldForceTxn",
                          },
                        });
                      }
                    }}
                    isRejectMobDisable={!services?.includes("AFieldForceTxn")}
                    approveMobClick={() => {
                      if (services?.includes("AFieldForceTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AFieldForceTxn",
                          },
                        });
                      }
                    }}
                    isApproveMobDisable={!services?.includes("AFieldForceTxn")}
                  />

                  <div className="flex flex-col w-width-full my-margin-md">
                    <div className="py-padding-sm px-padding-md bg-primary-card text-font-sm text-text-primary text-left font-semibold w-width-full">
                      Quick Actions
                    </div>

                    <div className="grid grid-cols-1 w-width-full bg-primary-nav border-b border-primary-bg">
                      <TopNavSmallButton
                        btnText={viewTxnDetails[0]?.category_id?.category_name}
                        btnType="button"
                        icon={categoryIcon?.url}
                        imgColor={categoryIcon?.colour}
                        handleFunction={() => {
                          if (type === "bene_txn_detail_modal") {
                            actionRestricted();
                          } else {
                            setHistoryPopup(true);
                            setTxnHistoryid(
                              viewTxnDetails[0]?.field_force_account_id,
                            );
                            setTxnHistoryAccountName(
                              viewTxnDetails[0]?.field_force_account_name,
                            );
                            setcategoryName(
                              viewTxnDetails[0]?.category_id?.category_name,
                            );
                          }
                        }}
                        isDisabled={type === "bene_txn_detail_modal"}
                        enabledTextColor="var(--text-primary)"
                        enabledBgColor="var(--primary-nav-act)"
                        disabledBgColor="var(--primary-nav-act)"
                        hoverOption="white"
                        fullWidthRequired={true}
                      />
                    </div>
                    <div className={` w-width-full bg-primary-nav`}>
                      <div className=" relative w-full ">
                        <TopNavSmallButton
                          btnText={
                            <>
                              Linked
                              <br />
                              request
                            </>
                          }
                          btnType="button"
                          icon={ICONS?.LINKED_WHITE_CIRCLE}
                          handleFunction={() => {
                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                            } else if (
                              viewTxnDetails?.[0]?.field_force_request_id
                            ) {
                              navigate(
                                `/field_force_transaction_dashboard/field_force_request_view_all/field_force_request_detail_page/${viewTxnDetails?.[0]?.field_force_request_id}`,
                              );
                            }
                          }}
                          isDisabled={
                            type === "bene_txn_detail_modal"
                              ? true
                              : !viewTxnDetails?.[0]?.field_force_request_id
                                ? true
                                : false
                          }
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          fullWidthRequired={true}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {shouldShowBankingHoursAlert && (
                <div className="max-w-tab-width-normal w-full Qlg:mx-auto Qlg:pt-padding-md px-padding-md mb-margin-md Qlg:mb-margin-base Qlg:px-padding-base">
                  <CommonAlertCard
                    title="Functioning outside banking hours"
                    texts="Transactions will be processed automatically during the next bank working day. Learn more"
                    highlightedText="Learn more"
                    onHighlightedTextClick={() =>
                      setShowBankingHoursPopup(true)
                    }
                  />
                </div>
              )}

              <div className="flex-row w-width-full timeline_box max-w-tab-width-normal m-auto flex items-end">
                <div
                  className={`bg-primary-card flex flex-col w-full lg:w-width-md mx-margin-md Qlg:mt-margin-md mt-margin-base lg:mx-margin-base h-auto  overflow-hidden relative rounded-bl-border-radius-md rounded-t-border-radius-md
                      ${
                        viewTxnDetails?.[0]?.distribution_logs !== undefined
                          ? "rounded-br-border-radius-md"
                          : "Qlg:rounded-br-none rounded-br-border-radius-md"
                      }
                    `}
                >
                  <div
                    className={`flex flex-col ${type === "bene_txn_detail_modal" && "opacity-light-opacity cursor-not-allowed"} w-full  h-auto   ${
                      viewTxnDetails?.[0]
                        ?.field_force_account_approval_status === "approved" &&
                      viewTxnDetails?.[0].lifecycle_status === "pending"
                        ? " rounded-bl-border-radius-md  rounded-br-border-radius-md"
                        : "rounded-b-border-radius-md"
                    } rounded-t-border-radius-md overflow-hidden relative`}
                  >
                    {/* TITLE */}
                    <div
                      className={`pt-px bg-primary-nav  rounded-tl-border-radius-md px-padding-md rounded-tr-border-radius-md`}
                    >
                      <p className="text-text-primary text-font-xs text-left font-semibold my-margin-sm">
                        Transaction Timeline
                      </p>
                      <div className="border-b border-primary-bg"></div>
                    </div>

                    <div ref={leftContentRef}>
                      <CommonTimeLineCard
                        logsData={viewTxnDetails}
                        handleApprovalClick={handleTimelinePopup}
                        handleDistributionClick={handleDistributionClick}
                        showApprovalTimeline={showApprovalTimeline}
                        showDistributionTimeline={showDistributionTimeline}
                        showDistributionRightIcon={true}
                        showApprovalLeftIcon={true}
                        isDisabled={
                          type === "bene_txn_detail_modal" ? true : false
                        }
                        cardType={"double"}
                      />
                    </div>
                  </div>
                </div>

                <div
                  className={`hidden lg:flex flex-col flex-grow mt-margin-md w-width-md`}
                >
                  {/* Web Timeline Component  */}
                  {/* ------------------------- */}
                  <TimelineStatusBar
                    showMobile={false}
                    key={viewTxnDetails?.[0]?.txn_id}
                    overrideAutoLoader
                    isLoading={loading}
                    failedToTakeaction={
                      false || "" || viewTxnDetails?.[0]?.message
                    }
                    failedToTakeactionReason={
                      false
                        ? "An error occurred while taking action on this transaction"
                        : ""
                          ? ""
                          : viewTxnDetails?.[0]?.message || ""
                    }
                    rejected={
                      viewTxnDetails?.[0]?.lifecycle_status === "rejected"
                    }
                    rejectedReason={
                      viewTxnDetails?.[0]?.rejection_reason?.length >
                      RejectReasonLength.lengthOfDecline
                        ? viewTxnDetails?.[0]?.rejection_reason.slice(0, 150) +
                          "..."
                        : viewTxnDetails?.[0]?.rejection_reason
                    }
                    accountApprovalPending={
                      viewTxnDetails?.[0]
                        ?.field_force_account_approval_status === "pending" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    accountApprovalPendingSubHeader={
                      services?.includes("AFieldForceTxn")
                        ? "Account is not approved, approve account before approving transaction."
                        : "To approve the account, please contact the authorized person."
                    }
                    handleApprovalPendingBtn={() =>
                      services?.includes("FFAAccount")
                        ? setFieldForceAccountDetailPopup(true)
                        : navigate("/feature_not_assigned", {
                            state: {
                              unavailableService: "FFAAccount",
                            },
                          })
                    }
                    isApprovalPendingDisabled={
                      services?.find((service) => service === "FFAAccount") ===
                      undefined
                    }
                    furtherApprovalPending={
                      (viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        viewTxnDetails?.[0]?.approved === "N" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.action?.toLowerCase() === "approved" &&
                        viewTxnDetails?.[0]?.logs[
                          viewTxnDetails?.[0]?.logs.length -
                            GlobalConfiguration.lengthCheckOne
                        ]?.user_id === loginid?.employees?.id) ||
                      (viewTxnDetails?.[0]?.last_updated_status ===
                        "Approved" &&
                        viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                        !services?.includes("AFieldForceTxn"))
                    }
                    furtherApprovalPendingSubHeader={
                      viewTxnDetails?.[0]?.lifecycle_status === "pending" &&
                      viewTxnDetails?.[0]?.approved === "N" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.action?.toLowerCase() === "approved" &&
                      viewTxnDetails?.[0]?.logs[
                        viewTxnDetails?.[0]?.logs.length -
                          GlobalConfiguration.lengthCheckOne
                      ]?.user_id === loginid?.employees?.id
                        ? "This transaction has been approved by you, but it requires another user's approval before settlement."
                        : viewTxnDetails?.[0]?.last_updated_status ===
                              "Approved" &&
                            viewTxnDetails?.[0]?.lifecycle_status ===
                              "pending" &&
                            !services?.includes("AFieldForceTxn")
                          ? "This transaction requires another user's approval before settlement."
                          : ""
                    }
                    pending={
                      viewTxnDetails?.[0]
                        ?.field_force_account_approval_status === "approved" &&
                      viewTxnDetails?.[0]?.lifecycle_status === "pending"
                    }
                    whichBtnClicked={
                      btnClicked?.[viewTxnDetails?.[0]?.txn_id] || "none"
                    }
                    rejectClick={() => {
                      if (services?.includes("AFieldForceTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Reject",
                        }));
                        handleDeclinedDetails(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AFieldForceTxn",
                          },
                        });
                      }
                    }}
                    isRejectDisable={!services?.includes("AFieldForceTxn")}
                    approveClick={() => {
                      if (services?.includes("AFieldForceTxn")) {
                        setbtnClicked((prev) => ({
                          ...prev,
                          [viewTxnDetails?.[0]?.txn_id]: "Approve",
                        }));
                        handleApproveTransaction(viewTxnDetails?.[0]?.txn_id);
                      } else {
                        navigate("/feature_not_assigned", {
                          state: {
                            unavailableService: "AFieldForceTxn",
                          },
                        });
                      }
                    }}
                    isApproveDisable={!services?.includes("AFieldForceTxn")}
                  />

                  {/* ------------------------- */}
                </div>
              </div>

              <div
                className={`details-div-trans lg:mb-margin-md bg-primary-bg lg:pt-padding-base ${
                  type === "bene_txn_detail_modal" ? "w-width-full" : "w-screen"
                }`}
              >
                <div className="detail-section-trans h-auto bg-primary-bg m-auto max-w-tab-width-normal">
                  <div className="mt-margin-md flex">
                    <div className="mx-margin-md flex gap-gap-sm bg-primary-card w-auto ml-margin-md lg:ml-margin-base rounded-border-radius-md overflow-x-auto no-scrollbar">
                      <SwitcherTabs
                        initialActiveTab={
                          showCategorySpecificDetails
                            ? "Category specific data"
                            : showAssignedLabels
                              ? "Labels"
                              : "category specific details"
                        }
                        tabs={[
                          {
                            label: "Category specific details",
                            key: "category specific details",
                            handler: toggleCategorySpecificDetails,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Support details",
                            key: "support details",
                            handler: toggleSupportDetails,
                          },
                          {
                            label: "Request details",
                            key: "request details",
                            handler: toggleRequestDetails,
                          },
                        ]}
                        setIndex={setIndex}
                      />
                    </div>
                  </div>

                  {index === GlobalConfiguration?.lengthCheckZero && (
                    <div className={animationClass}>
                      <div className="flex flex-col lg:flex-row items-start gap-gap-md pb-padding-md text-text-primary mt-margin-md px-padding-md lg:px-padding-base">
                        <>
                          {validItems?.filter((item) => {
                            const dataType = item?.data_type?.toLowerCase();
                            return ![
                              "hyperlink",
                              "file",
                              "image",
                              "upload",
                            ].includes(dataType);
                          }).length === GlobalConfiguration.lengthCheckZero &&
                          !attachments.length ? (
                            <div className="w-details-card-md flex flex-col p-padding-md gap-gap-md bg-primary-card rounded-border-radius-md">
                              <div className="text-text-primary text-font-sm font-semibold">
                                {TEXT?.CATEGORY_SPECIFIC_DETAILS}
                              </div>
                              <p className="text-text-secondary text-font-xs font-normal">
                                Category specific data are not supported for the
                                selected category.
                              </p>
                            </div>
                          ) : (
                            <>
                              {(() => {
                                const filteredItems = validItems?.filter(
                                  (item) =>
                                    ![
                                      "hyperlink",
                                      "file",
                                      "image",
                                      "upload",
                                    ].includes(item?.data_type?.toLowerCase()),
                                );

                                return (
                                  <>
                                    {!!filteredItems?.length && (
                                      <CommonDetailCard
                                        cardTitle={
                                          TEXT?.CATEGORY_SPECIFIC_DETAILS
                                        }
                                        numCols={
                                          !attachments?.length &&
                                          filteredItems?.length >
                                            GlobalConfiguration.lengthCheckOne
                                            ? GlobalConfiguration.lengthCheckThree
                                            : filteredItems?.length ===
                                                GlobalConfiguration.lengthCheckOne
                                              ? GlobalConfiguration.lengthCheckOne
                                              : GlobalConfiguration.lengthCheckTwo
                                        }
                                        variant="third"
                                        entries={filteredItems?.map(
                                          (subItem, index) => {
                                            switch (subItem?.data_type) {
                                              case "toggle":
                                                return {
                                                  content: subItem?.value
                                                    ? "Yes"
                                                    : "No",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "multi_select_list":
                                                return {
                                                  content:
                                                    subItem?.value?.length !==
                                                    GlobalConfiguration.lengthCheckZero
                                                      ? subItem?.value?.join(
                                                          ", ",
                                                        )
                                                      : "Not given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                };
                                              case "date_range":
                                                return {
                                                  content: subItem?.value
                                                    ?.start_date
                                                    ? `${subItem?.value.start_date} - ${subItem?.value.end_date}`
                                                    : "Not given",
                                                  heading:
                                                    "From date - To date",
                                                  type: "text",
                                                };
                                              case "from_year_to_year":
                                                return {
                                                  content: subItem?.value?.from
                                                    ? `${subItem?.value.from} - ${subItem?.value.to}`
                                                    : "Not given",
                                                  heading:
                                                    "From year - To year",
                                                  type: "text",
                                                };
                                              default:
                                                return {
                                                  content:
                                                    subItem?.value ||
                                                    "Not given",
                                                  heading: subItem?.name,
                                                  type: "text",
                                                  onClick: undefined,
                                                };
                                            }
                                          },
                                        )}
                                      />
                                    )}
                                  </>
                                );
                              })()}
                            </>
                          )}
                        </>

                        {attachments?.length >
                          GlobalConfiguration?.lengthCheckZero && (
                          <>
                            <CommonDetailCard
                              cardTitle={globalText?.ATTACHMENTS}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={attachments.map((obj, index) => {
                                switch (obj.data_type.toLowerCase()) {
                                  case "hyperlink":
                                    return {
                                      content: obj?.value ?? "#",
                                      heading: "URL",
                                      type: "link",
                                    };
                                  default: {
                                    let ob = obj.value;
                                    const mt =
                                      ob?.metadata?.mime_type ??
                                      "application/octet-stream";
                                    switch (true) {
                                      case mt?.startsWith("image/"):
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            url: ob?.file_url,
                                            onUrlClick: () => {
                                              setOpenImageUrl(true);
                                              setSelectedImage({
                                                name: ob?.metadata?.filename,
                                                url: ob?.file_url,
                                              });
                                            },
                                          },
                                          heading:
                                            ob?.metadata?.filename || "Image",
                                          type: "image",
                                        };
                                      default:
                                        return {
                                          content: {
                                            fileName: ob?.metadata?.filename,
                                            size: ob?.metadata?.size ?? "0",
                                            mimeType: mt,
                                            onUrlClick: () => {
                                              window
                                                .open(ob?.file_url, "_blank")
                                                .focus();
                                            },

                                            url: ob?.file_url,
                                          },
                                          heading:
                                            ob?.metadata?.filename || "File",
                                          type: "file",
                                        };
                                    }
                                  }
                                }
                              })}
                            />
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckOne && (
                    <div className={animationClass}>
                      <div className="mt-margin-md mb-margin-md">
                        <CommonContainerCard
                          header="Assigned Labels"
                          iconIsDisabled={
                            !(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            ) || type === "bene_txn_detail_modal"
                          }
                          subheader={TEXT?.LABELS_USAGE_NOTE}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();

                            if (!(
                              services?.includes("ALabel") &&
                              services?.includes("RLabel")
                            )) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }

                            if (type === "bene_txn_detail_modal") {
                              actionRestricted();
                              return;
                            }

                            setShowLabelsPopup(true);
                          }}
                        >
                          <div className="flex mb-margin-sm flex-wrap w-width-full gap-gap-sm overflow-x-auto">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <Chips
                                    key={index}
                                    txtChip={item}
                                    enabledBgColor="var(--primary-nav)"
                                    disableIcon={true}
                                    handleFunction={(e) => {
                                      e.stopPropagation();
                                      return;
                                    }}
                                    enabledTextColor="var(--text-primary)"
                                  />
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                Not assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckTwo && (
                    <div className={animationClass}>
                      {viewTxnDetails?.map((account) => {
                        let originItemList = [
                          {
                            content:
                              (account?.logs?.[0]?.user_full_name ?? "") +
                              " " +
                              (account?.logs?.[0]?.last_name
                                ? account.logs[0].last_name[0]?.toUpperCase() +
                                  account.logs[0].last_name
                                : ""),
                            heading: "Created by",
                            type: "text",
                          },
                          {
                            content: formatDateViewAll(
                              account?.created_on,
                              true,
                              true,
                            ),
                            heading: "Created on",
                            type: "text",
                          },
                        ];

                        let supportItemList = [
                          {
                            content: account?.txn_id,
                            heading: "Transaction ID",
                            type: "textWithButton",
                            iconArray: [
                              {
                                onClick: () =>
                                  handleSupportIdCopy(
                                    account?.txn_id,
                                    "txn_id",
                                  ),
                                title:
                                  copiedSupportField === "txn_id"
                                    ? "Copied"
                                    : "Copy to clipboard",
                                icon:
                                  copiedSupportField === "txn_id"
                                    ? ICONS?.SELECTED_WITH_GREEN_CIRCLE
                                    : ICONS?.COPY,
                              },
                            ],
                          },
                        ];
                        return (
                          <div
                            className={`flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base ${
                              account?.distribution_lifecycle_status ===
                              "distribution_complete"
                                ? "justify-between gap-gap-md"
                                : "gap-gap-md lg:gap-gap-md"
                            }`}
                          >
                            <CommonDetailCard
                              cardTitle={TEXT?.ORIGIN_DETAILS}
                              variant="third"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              entries={originItemList}
                            />

                            <CommonDetailCard
                              cardTitle={TEXT?.SUPPORT_DETAILS}
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              variant="third"
                              entries={supportItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {index === GlobalConfiguration?.lengthCheckThree && (
                    <div className={animationClass}>
                      {viewTxnDetails?.map((account) => {
                        const currentRequestData =
                          String(requestDataRequestId) ===
                          String(account?.field_force_request_id)
                            ? requestData
                            : null;
                        const requestItemList = [
                          {
                            heading: "Requested by",
                            content:
                              [
                                currentRequestData?.logs?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.first_name,
                                currentRequestData?.logs?.[
                                  GlobalConfiguration.lengthCheckZero
                                ]?.last_name,
                              ]
                                .filter(Boolean)
                                .join(" ") || "N/A",
                            type: "text",
                          },
                          {
                            heading: "Requested on",
                            content:
                              currentRequestData?.created_on != null
                                ? formatDateViewAll(
                                    currentRequestData.created_on,
                                    true,
                                    true,
                                  )
                                : "N/A",
                            type: "text",
                          },
                          {
                            heading: "User ID",
                            content: data?.employees?.user_id || "N/A",
                            type: "text",
                          },
                        ];

                        return (
                          <div
                            key={account?.txn_id}
                            className="flex flex-col lg:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md"
                          >
                            <CommonDetailCard
                              cardTitle={TEXT?.REQUEST_DETAILS}
                              variant="third"
                              numCols={GlobalConfiguration?.lengthCheckOne}
                              entries={requestItemList}
                            />
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default FieldForceTransactionDetails;
